// =====================================================
// API — Documentos adjuntos a presupuestos
// =====================================================

export interface BudgetDocument {
  id: string;
  budgetId: string;
  budgetNumber: string;
  rootBudgetId: string;
  documentTypeId: string;
  documentTypeName: string;
  documentTypeCode: string;
  requiresCustomTitle: boolean;
  customTitle: string | null;
  fileName: string;
  fileSize: number;
  uploadedById: string;
  uploadedByName: string | null;
  createdAt: string;
}

const BASE = '/api/v1';

function getToken(): string {
  return localStorage.getItem('imi_access_token') || '';
}

export const budgetDocumentsApi = {
  getAll: async (budgetId: string): Promise<BudgetDocument[]> => {
    const res = await fetch(`${BASE}/budgets/${budgetId}/documents`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    if (!res.ok) throw new Error('Error al cargar documentos');
    return res.json();
  },

  upload: async (
    budgetId: string,
    documentTypeId: string,
    file: File,
    customTitle?: string,
  ): Promise<BudgetDocument> => {
    const form = new FormData();
    form.append('file', file);
    form.append('documentTypeId', documentTypeId);
    if (customTitle) form.append('customTitle', customTitle);

    const res = await fetch(`${BASE}/budgets/${budgetId}/documents`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: form,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || 'Error al subir el documento');
    }
    return res.json();
  },

  getViewUrl: (budgetId: string, documentId: string): string =>
    `${BASE}/budgets/${budgetId}/documents/${documentId}/view`,

  delete: async (budgetId: string, documentId: string): Promise<void> => {
    const res = await fetch(`${BASE}/budgets/${budgetId}/documents/${documentId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    if (!res.ok) throw new Error('Error al eliminar el documento');
  },

  /**
   * Documentos adjuntos agregados de TODOS los presupuestos del paciente
   * en el centro activo.
   */
  getByPatient: async (patientId: string): Promise<BudgetDocument[]> => {
    const res = await fetch(`${BASE}/patient-documents/${patientId}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    if (!res.ok) throw new Error('Error al cargar documentos del paciente');
    return res.json();
  },
};
